<template>
  <div class="bowl">
    <vue3-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="300000"
      filename="finance"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="f4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2Pdf"
    >
      <template #pdf-content>
        <section>
          <master-pdf-finance-vue v-if="datas === 'finance'" />
          <masterPdfContractVue v-if="datas === 'contract'" />
          <masterPdfLegasVue v-if="datas === 'legal'" />
          <masterPdfGeneration v-if="datas === 'generation'" />
          <masterPdfDistribution v-if="datas === 'distribution'" />
          <masterPdfMoonshot v-if="datas === 'moonshot'" />
        </section>
      </template>
    </vue3-html2pdf>
  </div>
</template>

<script>
import Vue3Html2pdf from "vue3-html2pdf";
import masterPdfMoonshot from "./components/master-pdf-moonshot.vue";
import masterPdfDistribution from "./components/master--pdf-distribution.vue";
import masterPdfGeneration from "./components/master-pdf-generation.vue";
import masterPdfContractVue from "./components/master-pdf-contract.vue";
import masterPdfFinanceVue from "./components/master-pdf-finance.vue";
import masterPdfLegasVue from "./components/master-pdf-legas.vue";
export default {
  components: {
    Vue3Html2pdf,
    masterPdfMoonshot,
    masterPdfDistribution,
    masterPdfGeneration,
    masterPdfFinanceVue,
    masterPdfContractVue,
    masterPdfLegasVue,
  },
  data() {
    return {
      dialog1: false,
    };
  },
  computed: {
    htmlToPdfOptions() {
      return {
        filename: this.title,
        margin: [5, 0, 10, 0], //top, left, buttom, right
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 3,
          bottom: 20,
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        jsPDF: {
          unit: "mm",
          orientation: "landscape",
        },
      };
    },
  },
  methods: {
    generateReport() {
      this.dialog1 = true;
      this.$refs.html2Pdf.generatePdf();
      this.dialog1 = false;
    },
  },
  props: {
    datas: String,
    // status: Number,
    // title: String,
    // titlePeriod: String,
    // yearProps: Object,
  },
};
</script>

<style scoped></style>
